import styled from 'styled-components'

const ForgotPasswordLink = styled.div`
    color: ${props => props.theme.colors.orange};
    font-size: ${props => props.theme.fontSizeSmall};
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
`

export default ForgotPasswordLink
